import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '../../@core/store/store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  GetChartFromSessionLoadedState, GetChartFromSessionLoadingErrorState, GetChartFromSessionLoadingState,
  GetChartHIstoryLoadedState,
  GetChartHIstoryLoadingErrorState, GetChartHIstoryLoadingState, GetChartLoadedState, GetChartLoadingErrorState,
  GetChartLoadingState, TextSpeakLoadedState, TextSpeakLoadingErrorState, TextSpeakLoadingState,
  GetChartFromSessionStreamChunkState, GetChartFromSessionChainStartState,
  GetChartFromSessionToolStartState,
  GetChartFromSessionToolEndState,
  GetChartFromSessionModelEndState,
  PromptSpeakLoadingState,
  PromptSpeakLoadingErrorState,
  PromptSpeakLoadedState,
  GetTokenErrorState,
  OpenAttendanceCalendarState
} from './ai-chartwoot-buddy.state';
import { environment } from '../../../environments/environment';
import { AppLocalStorage } from '../../@core/utils/local-storage.util';
import { Session } from '../../@core/session/session.model';
import { TokenService } from '../../@core/token/token.service';


@Injectable({
  providedIn: 'root'
})
export class AiChatwootService extends Store.AbstractService {
  constructor(private http: HttpClient, private tokenService: TokenService) {
    super();
  }
  getAlinaPrompt(reqBody): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new PromptSpeakLoadingState());
    }, 0);

    const path = environment.api.genie.promptData.endpoint;

    me.controller.post(path, reqBody, null, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new PromptSpeakLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new PromptSpeakLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }



  getChatData(reqBody): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new GetChartLoadingState());
    }, 0);

    const path = environment.api.genie.chatBot.endpoint;

    me.controller.post(path, reqBody, null, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new GetChartLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new GetChartLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  getHistoryData(email): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new GetChartHIstoryLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(environment.api.genie.history.endpoint, {
      email
    })

    me.controller.get(path, null, null, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new GetChartHIstoryLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new GetChartHIstoryLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }


  getTextFromSession(session_id, email, accessToken) {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new GetChartFromSessionLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(environment.api.genie.session.endpoint,
      { session_id, email }
    )

    me.controller.get(path, null, null, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new GetChartFromSessionLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new GetChartFromSessionLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  /**
   * Streams chat responses using WebSocket and emits events via RxJS Subject.
   * @param session_id Session ID
   * @param email User email
   * @param query Query string
   */
  async getTextFromSessionStream(session_id: string, email: string, query: string,access_token:string,localtime:any,client:string) {
    const output = new Subject<Store.State>();
    let ws: WebSocket | null = null;
    var timeoutHandle:any;
    var TIMEOUT_MS = 120000; // 30 seconds
    function resetTimeout() {
      clearTimeout(timeoutHandle);
      timeoutHandle = setTimeout(function () {
        if (ws) {
          ws.close();
          output.error(new GetChartFromSessionLoadingErrorState({ status: '0', message: 'Stream timeout error' }));
        }
      }, TIMEOUT_MS);
    }

    setTimeout(() => {
      output.next(new GetChartFromSessionLoadingState());
    }, 0);

    try {
      const token = await this.tokenService.getAccessToken();
      const baseUrl = environment.api.core.base2;
      ws = new WebSocket(baseUrl + environment.api.buddy.ws.endpoint + "?access_token=" + token);

      ws.onopen = () => {
        ws!.send(JSON.stringify({ email, session_id, query,access_token,localtime,client }));
        resetTimeout();
      };

      ws.onmessage = (event) => {
        try {
          const eventData = JSON.parse(event.data);
          // Stream chunk event
          if (eventData.event === 'on_chat_model_stream') {
            const chunk = eventData.data?.chunk;
            if (chunk && chunk.content) {
              output.next(new GetChartFromSessionStreamChunkState(chunk.content, eventData.run_id, eventData.metadata.langgraph_node,eventData.event));
            }
            resetTimeout()
            return;
          }
          if (eventData.event === 'open_attendance_calendar') {
            const chunk = eventData.data?.chunk;
            if (chunk && chunk.content) {
              output.next(new GetChartFromSessionStreamChunkState(chunk.content, eventData.run_id, eventData.metadata.langgraph_node,eventData.event));
            }
            resetTimeout()
            return;
          }

          if (eventData.event === 'open_leave_calendar') {
            const chunk = eventData.data?.chunk;
            console.log(eventData)
            if (chunk && chunk.content) {
              output.next(new GetChartFromSessionStreamChunkState(chunk.content, eventData.run_id, eventData.metadata.langgraph_node,eventData.event));
            }
            resetTimeout()
            return;
          }
          // Other events
          switch (eventData.event) {
            case 'start':
              output.next(new GetChartFromSessionChainStartState("start"));
              break;
            case 'open_attendance_calendar':
              const chunk = eventData.data?.chunk;
              if (chunk && chunk.content) {
                const contentData = JSON.parse(chunk.content);
                output.next(new OpenAttendanceCalendarState(contentData));
              }
              break;
            case 'token_error':
              output.next(new GetTokenErrorState("token_error", eventData?.message || 'Token error'));
              break;
            case 'done':
              output.complete();
              clearInterval(timeoutHandle);
              ws?.close();
              break;
            default:
              // Ignore other events
              break;
          }
        } catch (err: any) {
          output.error(new GetChartFromSessionLoadingErrorState({ status: '0', message: err?.message || 'Stream error' }));
        }
        resetTimeout();
      };

      ws.onerror = (err: any) => {
        output.error(new GetChartFromSessionLoadingErrorState({ status: '0', message: err?.message || 'WebSocket error' }));
        output.complete();
        clearTimeout(timeoutHandle);
      };

      ws.onclose = () => {
        output.complete();
        clearTimeout(timeoutHandle);
      };
    } catch (err: any) {
      output.error(new GetChartFromSessionLoadingErrorState({ status: '0', message: err?.message || 'WebSocket error' }));
      output.complete();
    }

    return output;
  }


  getTextFromSessionStreamold(session_id: string, email: string, query: string) {
    const output = new Subject<Store.State>();

    // Timeout handling (reusing your pattern)
    let timeoutHandle: any;
    const TIMEOUT_MS = 120000; // 120s
    function resetTimeout() {
      clearTimeout(timeoutHandle);
      timeoutHandle = setTimeout(() => {
        controller.abort(); // cancel the streaming request
        output.error(new GetChartFromSessionLoadingErrorState({ status: '0', message: 'Stream timeout error' }));
      }, TIMEOUT_MS);
    }

    setTimeout(() => {
      output.next(new GetChartFromSessionLoadingState());
    }, 0);

    // Build request
    const session = AppLocalStorage.get("SESSION", "SESSION") as Session;
    const baseUrl = environment.api.core.base2; // e.g., http://localhost:8000/api
    // Adjust endpoint path if needed. This should point to your FastAPI router base + /chat/stream
    // If your API is mounted under /api, you may need `${baseUrl}/chat/stream`
    const url =
      `${baseUrl}api/chat/stream`;

    // Optional: Use headers if you prefer header-based token transport
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session?.token}` // if using header instead of query
      // 'access_token': session?.token || ''       // alternative header name supported by backend
    };

    const body = JSON.stringify({ email, session_id, query });
    const controller = new AbortController();

    (async () => {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers,
          body,
          signal: controller.signal
        });

        if (!response.ok) {
          output.error(new GetChartFromSessionLoadingErrorState({
            status: String(response.status),
            message: `HTTP error: ${response.status} ${response.statusText}`
          }));
          output.complete();
          return;
        }

        if (!response.body) {
          output.error(new GetChartFromSessionLoadingErrorState({
            status: '0',
            message: 'No response body for streaming'
          }));
          output.complete();
          return;
        }

        // Start timer when stream begins
        resetTimeout();

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        // Helper to handle parsed event JSON
        const handleEvent = (eventData: any) => {
          // token_error event
          if (eventData.event === 'token_error') {
            output.next(new GetTokenErrorState('token_error', eventData?.message || 'Token error'));
            return;
          }

          // Final answer chunks
          if (eventData.event === 'on_chat_model_stream') {
            const chunk = eventData.data?.chunk;
            if (chunk && chunk.content) {
              output.next(new GetChartFromSessionStreamChunkState(
                chunk.content,
                eventData.run_id,
                eventData?.metadata?.langgraph_node,
                eventData?.name
              ));
            }
            return;
          }

          // Other events
          switch (eventData.event) {
            case 'start':
              output.next(new GetChartFromSessionChainStartState('start'));
              break;
            case 'done':
              output.complete();
              clearTimeout(timeoutHandle);
              controller.abort();
              break;
            case 'error':
              output.error(new GetChartFromSessionLoadingErrorState({
                status: '0',
                message: eventData?.message || 'Stream error'
              }));
              clearTimeout(timeoutHandle);
              controller.abort();
              break;
            default:
              // ignore
              break;
          }
        };

        // Read the stream, parse SSE frames
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });

          // SSE frames separated by 2 newlines
          const parts = buffer.split('\n\n');
          buffer = parts.pop() || '';

          for (const block of parts) {
            // Each block may contain multiple lines, look for "data: {json}"
            const lines = block.split('\n');
            for (const line of lines) {
              if (!line.startsWith('data:')) continue;
              const jsonStr = line.slice(5).trim();
              if (!jsonStr) continue;
              try {
                const eventData = JSON.parse(jsonStr);
                handleEvent(eventData);
              } catch (e: any) {
                output.error(new GetChartFromSessionLoadingErrorState({
                  status: '0',
                  message: `Failed to parse SSE data JSON: ${e?.message || e}`
                }));
              }
            }
          }

          resetTimeout();
        }

        // Stream naturally ended — mark as done if server didn't send done
        output.complete();
        clearTimeout(timeoutHandle);
      } catch (err: any) {
        if (err?.name === 'AbortError') {
          // aborted by timeout or finish, already handled
        } else {
          output.error(new GetChartFromSessionLoadingErrorState({
            status: '0',
            message: err?.message || 'Stream error'
          }));
        }
        clearTimeout(timeoutHandle);
      }
    })();

    return output;
  }

  /**
   * Transcribes audio blob to text using speech-to-text API
   * @param audioBlob The audio blob to transcribe
   * @returns Observable with transcription response
   */
  transcribeAudio(audioBlob: Blob) {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new TextSpeakLoadingState());
    }, 0);

    const path = environment.api.genie.speechToText.endpoint;
    const formData = new FormData();
    formData.append('file', audioBlob, 'recording.wav');
    formData.append('language', 'en-US');

    me.controller.post(path, formData, null, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new TextSpeakLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new TextSpeakLoadingErrorState(e));
        output.complete();
      }
    );

    return output;
  }

}
